export default __webpack_public_path__ + "static/years-bg-image-45c61e11e8e8fd67e3cafa59bc479c83.jpg";